import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonImg, IonCheckbox } from '@ionic/react';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

import '../../../css/zsavaApp.css';

export function CapabilitiesModal(props) {

    let zasava_context = useContext(Auth_Zasava_Context);

    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    let [merchantAccountID, setMerchantAccountID] = useState(props.data.data_merchantID);



    let [checked_forms, setchecked_forms] = useState(false);
    let [checked_hotel, setChecked_hotel] = useState(false);
    let [checked_employees, setChecked_employees] = useState(false);
    let [checked_proService, setChecked_proService] = useState(false);
    let [checked_retail, setChecked_retail] = useState(false);
    let [checked_jobs, setChecked_jobs] = useState(false);

    let [checked_forms_active, setChecked_forms_active] = useState(false);
    let [checked_hotel_active, setChecked_hotel_active] = useState(false);
    let [checked_employees_active, setChecked_employees_active] = useState(false);
    let [checked_proService_active, setChecked_proService_active] = useState(false);
    let [checked_retail_active, setChecked_retail_active] = useState(false);
    let [checked_jobs_active, setChecked_jobs_active] = useState(false);

    
    let [checked_forms_suspend, setChecked_forms_suspend] = useState(false);
    let [checked_hotel_suspend, setChecked_hotel_suspend] = useState(false);
    let [checked_employees_suspend, setChecked_employees_suspend] = useState(false);
    let [checked_proService_suspend, setChecked_proService_suspend] = useState(false);
    let [checked_retail_suspend, setChecked_retail_suspend] = useState(false);
    let [checked_jobs_suspend, setChecked_jobs_suspend] = useState(false);


    let [checked_forms_delete, setChecked_forms_delete] = useState(false);
    let [checked_hotel_delete, setChecked_hotel_delete] = useState(false);
    let [checked_employees_delete, setChecked_employees_delete] = useState(false);
    let [checked_proService_delete, setChecked_proService_delete] = useState(false);
    let [checked_retail_delete, setChecked_retail_delete] = useState(false);
    let [checked_jobs_delete, setChecked_jobs_delete] = useState(false);

    let [checked_forms_inactive, setChecked_forms_inactive] = useState(false);
    let [checked_hotel_inactive, setChecked_hotel_inactive] = useState(false);
    let [checked_employees_inactive, setChecked_employees_inactive] = useState(false);
    let [checked_proService_inactive, setChecked_proService_inactive] = useState(false);
    let [checked_retail_inactive, setChecked_retail_inactive] = useState(false);
    let [checked_jobs_inactive, setChecked_jobs_inactive] = useState(false);

    let [accessStatus_forms, setDatabaseAccess_forms] = useState('no');
    let [accessStatus_hotel, setDatabaseAccess_hotel] = useState('no');
    let [accessStatus_employees, setDatabaseAccess_employees] = useState('no');
    let [accessStatus_proService, setDatabaseAccess_proService] = useState('no');
    let [accessStatus_retail, setDatabaseAccess_retail] = useState('no');
    let [accessStatus_jobs, setDatabaseAccess_jobs] = useState('no');

    let [accessStatus_forms_active, setDatabaseAccess_forms_active] = useState('no');
    let [accessStatus_hotel_active, setDatabaseAccess_hotel_active] = useState('no');
    let [accessStatus_employees_active, setDatabaseAccess_employees_active] = useState('no');
    let [accessStatus_proService_active, setDatabaseAccess_proService_active] = useState('no');
    let [accessStatus_retail_active, setDatabaseAccess_retail_active] = useState('no');
    let [accessStatus_jobs_active, setDatabaseAccess_jobs_active] = useState('no');

    let [accessStatus_forms_suspend, setDatabaseAccess_forms_suspend] = useState('no');
    let [accessStatus_hotel_suspend, setDatabaseAccess_hotel_suspend] = useState('no');
    let [accessStatus_employees_suspend, setDatabaseAccess_employees_suspend] = useState('no');
    let [accessStatus_proService_suspend, setDatabaseAccess_proService_suspend] = useState('no');
    let [accessStatus_retail_suspend, setDatabaseAccess_retail_suspend] = useState('no');
    let [accessStatus_jobs_suspend, setDatabaseAccess_jobs_suspend] = useState('no');

    let [accessStatus_forms_delete, setDatabaseAccess_forms_delete] = useState('no');
    let [accessStatus_hotel_delete, setDatabaseAccess_hotel_delete] = useState('no');
    let [accessStatus_employees_delete, setDatabaseAccess_employees_delete] = useState('no');
    let [accessStatus_proService_delete, setDatabaseAccess_proService_delete] = useState('no');
    let [accessStatus_retail_delete, setDatabaseAccess_retail_delete] = useState('no');
    let [accessStatus_jobs_delete, setDatabaseAccess_jobs_delete] = useState('no');

    let [accessStatus_forms_inactive, setDatabaseAccess_forms_inactive] = useState('no');
    let [accessStatus_hotel_inactive, setDatabaseAccess_hotel_inactive] = useState('no');
    let [accessStatus_employees_inactive, setDatabaseAccess_employees_inactive] = useState('no');
    let [accessStatus_proService_inactive, setDatabaseAccess_proService_inactive] = useState('no');
    let [accessStatus_retail_inactive, setDatabaseAccess_retail_inactive] = useState('no');
    let [accessStatus_jobs_inactive, setDatabaseAccess_jobs_inactive] = useState('no');


    useEffect(() => {

        //alert('In CapabilitiesModal USEEFFECT');
        //alert(props.data.data_merchantID);

        if(props.openModal == true)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                //body: JSON.stringify({formData})
                body: JSON.stringify({
                    Tracker: '9008',
                    xMerchantAccountID:  props.data.data_merchantID,
                    sessionID: sessionID
                })
            }
    

            
            fetch(baseURL+'/admin_zsava_indexApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    /*alert('Inside Modal Capabilities FETCH');
                    alert(rows);
                    alert(cols);*/


                    if(cols[0] == 'yes')
                    {
                        setchecked_forms(true);
                        setDatabaseAccess_forms(cols[0]);
                    }
                    if(cols[1] == 'yes')
                    {
                        setChecked_hotel(true);
                        setDatabaseAccess_hotel(cols[1]);

                    }
                    if(cols[2] == 'yes')
                    {
                        setChecked_employees(true);
                        setDatabaseAccess_employees(cols[2]);

                    }
                    if(cols[3] == 'yes')
                    {
                        setChecked_proService(true);
                        setDatabaseAccess_proService(cols[3]);

                    }
                    if(cols[4] == 'yes')
                    {
                        setChecked_retail(true);
                        setDatabaseAccess_retail(cols[4]);

                    }
                    if(cols[5] == 'yes')
                    {
                        setChecked_jobs(true);
                        setDatabaseAccess_jobs(cols[5]);

                    }




                    if(cols[6] == 'yes')
                    {
                        setChecked_forms_active(true);
                        setDatabaseAccess_forms_active(cols[6]);
                    }
                    if(cols[7] == 'yes')
                    {
                        setChecked_hotel_active(true);
                        setDatabaseAccess_hotel_active(cols[7]);

                    }
                    if(cols[8] == 'yes')
                    {
                        setChecked_employees_active(true);
                        setDatabaseAccess_employees_active(cols[8]);

                    }
                    if(cols[9] == 'yes')
                    {
                        setChecked_proService_active(true);
                        setDatabaseAccess_proService_active(cols[9]);

                    }
                    if(cols[10] == 'yes')
                    {
                        setChecked_retail_active(true);
                        setDatabaseAccess_retail_active(cols[10]);

                    }
                    if(cols[11] == 'yes')
                    {
                        setChecked_jobs_active(true);
                        setDatabaseAccess_jobs_active(cols[11]);

                    }





                    if(cols[12] == 'yes')
                    {
                        setChecked_forms_suspend(true);
                        setDatabaseAccess_forms_suspend(cols[12]);
                    }
                    if(cols[13] == 'yes')
                    {
                        setChecked_hotel_suspend(true);
                        setDatabaseAccess_hotel_suspend(cols[13]);

                    }
                    if(cols[14] == 'yes')
                    {
                        setChecked_employees_suspend(true);
                        setDatabaseAccess_employees_suspend(cols[14]);

                    }
                    if(cols[15] == 'yes')
                    {
                        setChecked_proService_suspend(true);
                        setDatabaseAccess_proService_suspend(cols[15]);

                    }
                    if(cols[16] == 'yes')
                    {
                        setChecked_retail_suspend(true);
                        setDatabaseAccess_retail_suspend(cols[16]);

                    }
                    if(cols[17] == 'yes')
                    {
                        setChecked_jobs_suspend(true);
                        setDatabaseAccess_jobs_suspend(cols[17]);

                    }




                    if(cols[18] == 'yes')
                    {
                        setChecked_forms_delete(true);
                        setDatabaseAccess_forms_delete(cols[18]);
                    }
                    if(cols[19] == 'yes')
                    {
                        setChecked_hotel_delete(true);
                        setDatabaseAccess_hotel_delete(cols[19]);

                    }
                    if(cols[20] == 'yes')
                    {
                        setChecked_employees_delete(true);
                        setDatabaseAccess_employees_delete(cols[20]);

                    }
                    if(cols[21] == 'yes')
                    {
                        setChecked_proService_delete(true);
                        setDatabaseAccess_proService_delete(cols[21]);

                    }
                    if(cols[22] == 'yes')
                    {
                        setChecked_retail_delete(true);
                        setDatabaseAccess_retail_delete(cols[22]);

                    }
                    if(cols[23] == 'yes')
                    {
                        setChecked_jobs_delete(true);
                        setDatabaseAccess_jobs_delete(cols[23]);

                    }




                    if(cols[24] == 'yes')
                    {
                        setChecked_forms_inactive(true);
                        setDatabaseAccess_forms_inactive(cols[24]);
                    }
                    if(cols[25] == 'yes')
                    {
                        setChecked_hotel_inactive(true);
                        setDatabaseAccess_hotel_inactive(cols[25]);

                    }
                    if(cols[26] == 'yes')
                    {
                        setChecked_employees_inactive(true);
                        setDatabaseAccess_employees_inactive(cols[26]);

                    }
                    if(cols[27] == 'yes')
                    {
                        setChecked_proService_inactive(true);
                        setDatabaseAccess_proService_inactive(cols[27]);

                    }
                    if(cols[28] == 'yes')
                    {
                        setChecked_retail_inactive(true);
                        setDatabaseAccess_retail_inactive(cols[28]);

                    }
                    if(cols[29] == 'yes')
                    {
                        setChecked_jobs_inactive(true);
                        setDatabaseAccess_jobs_inactive(cols[29]);

                    }

                } 
            })
        }

    }, [props.openModal])


    function updateMerchantAccess() {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '9009',
                xMerchantAccountID:  merchantAccountID,
                xAccess_forms:  accessStatus_forms,
                xAccess_hotel:  accessStatus_hotel,
                xAccess_employees:  accessStatus_employees,
                xAccess_proService:  accessStatus_proService,
                xAccess_retail:  accessStatus_retail,
                xAccess_jobs:  accessStatus_jobs,
                xAccess_forms_active:  accessStatus_forms_active,
                xAccess_hotel_active:  accessStatus_hotel_active,
                xAccess_employees_active:  accessStatus_employees_active,
                xAccess_proService_active:  accessStatus_proService_active,
                xAccess_retail_active:  accessStatus_retail_active,
                xAccess_jobs_active:  accessStatus_jobs_active,
                xAccess_forms_suspend:  accessStatus_forms_suspend,
                xAccess_hotel_suspend:  accessStatus_hotel_suspend,
                xAccess_employees_suspend:  accessStatus_employees_suspend,
                xAccess_proService_suspend:  accessStatus_proService_suspend,
                xAccess_retail_suspend:  accessStatus_retail_suspend,
                xAccess_jobs_suspend:  accessStatus_jobs_suspend,
                xAccess_forms_delete:  accessStatus_forms_delete,
                xAccess_hotel_delete:  accessStatus_hotel_delete,
                xAccess_employees_delete:  accessStatus_employees_delete,
                xAccess_proService_delete:  accessStatus_proService_delete,
                xAccess_retail_delete:  accessStatus_retail_delete,
                xAccess_jobs_delete:  accessStatus_jobs_delete,
                xAccess_forms_inactive:  accessStatus_forms_inactive,
                xAccess_hotel_inactive:  accessStatus_hotel_inactive,
                xAccess_employees_inactive:  accessStatus_employees_inactive,
                xAccess_proService_inactive:  accessStatus_proService_inactive,
                xAccess_retail_inactive:  accessStatus_retail_inactive,
                xAccess_jobs_inactive:  accessStatus_jobs_inactive,
                sessionID: sessionID
            })
        }
        
        fetch(baseURL+'/admin_zsava_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })

    }

    function formsInvoiceHandler(e) 
    {
        if(e[0] == 'on' && e[1] == true)
        {
            setchecked_forms(e[1]);
            setDatabaseAccess_forms('yes');
            // setChecked_forms_active(false);
            // setDatabaseAccess_forms_active('no');
            // setChecked_forms_suspend(false);
            // setDatabaseAccess_forms_suspend('no');
            // setChecked_forms_delete(false);
            // setDatabaseAccess_forms_delete('no');
            // setChecked_forms_inactive(false);
            // setDatabaseAccess_forms_inactive('no');
        }
        else if(e[0] == 'active' && e[1] == true)
        {
            // setchecked_forms(false);
            // setDatabaseAccess_forms('no');
            setChecked_forms_active(e[1]);
            setDatabaseAccess_forms_active('yes');
            setChecked_forms_suspend(false);
            setDatabaseAccess_forms_suspend('no');
            setChecked_forms_delete(false);
            setDatabaseAccess_forms_delete('no');
            setChecked_forms_inactive(false);
            setDatabaseAccess_forms_inactive('no');
        }

        else if(e[0] == 'suspend' && e[1] == true)
        {
            // setchecked_forms(false);
            // setDatabaseAccess_forms('no');
            setChecked_forms_active(false);
            setDatabaseAccess_forms_active('no');
            setChecked_forms_suspend(e[1]);
            setDatabaseAccess_forms_suspend('yes');
            setChecked_forms_delete(false);
            setDatabaseAccess_forms_delete('no');
            setChecked_forms_inactive(false);
            setDatabaseAccess_forms_inactive('no');
        }
        else if((e[0] == 'delete' && e[1] == true))
        {
            // setchecked_forms(false);
            // setDatabaseAccess_forms('no');
            setChecked_forms_active(false);
            setDatabaseAccess_forms_active('no');
            setChecked_forms_suspend(false);
            setDatabaseAccess_forms_suspend('no');
            setChecked_forms_delete(e[1]);
            setDatabaseAccess_forms_delete('yes');
            setChecked_forms_inactive(false);
            setDatabaseAccess_forms_inactive('no');
        }
        else if((e[0] == 'inactive' && e[1] == true))
        {
            // setchecked_forms(false);
            // setDatabaseAccess_forms('no');
            setChecked_forms_active(false);
            setDatabaseAccess_forms_active('no');
            setChecked_forms_suspend(false);
            setDatabaseAccess_forms_suspend('no');
            setChecked_forms_delete(false);
            setDatabaseAccess_forms_delete('no');
            setChecked_forms_inactive(e[1]);
            setDatabaseAccess_forms_inactive('yes');
        }
    }

    function hotelManagementHandler(e)
    {

        if(e[0] == 'on' && e[1] == true)
        {
            setChecked_hotel(e[1]);
            setDatabaseAccess_hotel('yes');
            // setChecked_hotel_active(false);
            // setDatabaseAccess_hotel_active('no');
            // setChecked_hotel_suspend(false);
            // setDatabaseAccess_hotel_suspend('no');
            // setChecked_hotel_delete(false);
            // setDatabaseAccess_hotel_delete('no');
            // setChecked_hotel_inactive(false);
            // setDatabaseAccess_hotel_inactive('no');
        }
        if(e[0] == 'active' && e[1] == true)
        {
            // setChecked_hotel(e[1]);
            // setDatabaseAccess_hotel('yes');
            setChecked_hotel_active(e[1]);
            setDatabaseAccess_hotel_active('yes');
            setChecked_hotel_suspend(false);
            setDatabaseAccess_hotel_suspend('no');
            setChecked_hotel_delete(false);
            setDatabaseAccess_hotel_delete('no');
            setChecked_hotel_inactive(false);
            setDatabaseAccess_hotel_inactive('no');
        }

        else if(e[0] == 'suspend' && e[1] == true)
        {
            // setChecked_hotel(false);
            // setDatabaseAccess_hotel('no');
            setChecked_hotel_active(false);
            setDatabaseAccess_hotel_active('no');
            setChecked_hotel_suspend(e[1]);
            setDatabaseAccess_hotel_suspend('yes');
            setChecked_hotel_delete(false);
            setDatabaseAccess_hotel_delete('no');
            setChecked_hotel_inactive(false);
            setDatabaseAccess_hotel_inactive('no');
        }
        else if((e[0] == 'delete' && e[1] == true))
        {
            // setChecked_hotel(false);
            // setDatabaseAccess_hotel('no');
            setChecked_hotel_active(false);
            setDatabaseAccess_hotel_active('no');
            setChecked_hotel_suspend(false);
            setDatabaseAccess_hotel_suspend('no');
            setChecked_hotel_delete(e[1]);
            setDatabaseAccess_hotel_delete('yes');
            setChecked_hotel_inactive(false);
            setDatabaseAccess_hotel_inactive('no');
        }
        else if((e[0] == 'inactive' && e[1] == true))
        {
            // setchecked_hotel(false);
            // setDatabaseAccess_hotel('no');
            setChecked_hotel_active(false);
            setDatabaseAccess_hotel_active('no');
            setChecked_hotel_suspend(false);
            setDatabaseAccess_hotel_suspend('no');
            setChecked_hotel_delete(false);
            setDatabaseAccess_hotel_delete('no');
            setChecked_hotel_inactive(e[1]);
            setDatabaseAccess_hotel_inactive('yes');
        }
        
    }

    function employeeManagementHandler(e)
    {
        if(e[0] == 'on' && e[1] == true)
        {
            setChecked_employees(e[1]);
            setDatabaseAccess_employees('yes');
            // setChecked_employees_active(false);
            // setDatabaseAccess_employees_active('no');
            // setChecked_employees_suspend(false);
            // setDatabaseAccess_employees_suspend('no');
            // setChecked_employees_delete(false);
            // setDatabaseAccess_employees_delete('no');
            // setChecked_employees_inactive(false);
            // setDatabaseAccess_employees_inactive('no');
        }
        if(e[0] == 'active' && e[1] == true)
        {
            // setChecked_employees(e[1]);
            // setDatabaseAccess_employees('yes');
            setChecked_employees_active(e[1]);
            setDatabaseAccess_employees_active('yes');
            setChecked_employees_suspend(false);
            setDatabaseAccess_employees_suspend('no');
            setChecked_employees_delete(false);
            setDatabaseAccess_employees_delete('no');
            setChecked_employees_inactive(false);
            setDatabaseAccess_employees_inactive('no');
        }
        else if(e[0] == 'suspend' && e[1] == true)
        {
            // setChecked_employees(false);
            // setDatabaseAccess_employees('no');
            setChecked_employees_active(false);
            setDatabaseAccess_employees_active('no');
            setChecked_employees_suspend(e[1]);
            setDatabaseAccess_employees_suspend('yes');
            setChecked_employees_delete(false);
            setDatabaseAccess_employees_delete('no');
            setChecked_employees_inactive(false);
            setDatabaseAccess_employees_inactive('no');
        }
        else if((e[0] == 'delete' && e[1] == true))
        {
            // setChecked_employees(false);
            // setDatabaseAccess_employees('no');
            setChecked_employees_active(false);
            setDatabaseAccess_employees_active('no');
            setChecked_employees_suspend(false);
            setDatabaseAccess_employees_suspend('no');
            setChecked_employees_delete(e[1]);
            setDatabaseAccess_employees_delete('yes');
            setChecked_employees_inactive(false);
            setDatabaseAccess_employees_inactive('no');
        }
        else if((e[0] == 'inactive' && e[1] == true))
        {
            // setChecked_employees(false);
            // setDatabaseAccess_employees('no');
            setChecked_employees_active(false);
            setDatabaseAccess_employees_active('no');
            setChecked_employees_suspend(false);
            setDatabaseAccess_employees_suspend('no');
            setChecked_employees_delete(false);
            setDatabaseAccess_employees_delete('no');
            setChecked_employees_inactive(e[1]);
            setDatabaseAccess_employees_inactive('yes');
        }
    }

    function proServiceManagementHandler(e)
    {
        if(e[0] == 'on' && e[1] == true)
        {
            setChecked_proService(e[1]);
            setDatabaseAccess_proService('yes');
            // setChecked_proService_active(false);
            // setDatabaseAccess_proService_active('no');
            // setChecked_proService_suspend(false);
            // setDatabaseAccess_proService_suspend('no');
            // setChecked_proService_delete(false);
            // setDatabaseAccess_proService_delete('no');
            // setChecked_proService_inactive(false);
            // setDatabaseAccess_proService_inactive('no');
        }
        if(e[0] == 'active' && e[1] == true)
        {
            // setChecked_proService(e[1]);
            // setDatabaseAccess_proService('yes');
            setChecked_proService_active(e[1]);
            setDatabaseAccess_proService_active('yes');
            setChecked_proService_suspend(false);
            setDatabaseAccess_proService_suspend('no');
            setChecked_proService_delete(false);
            setDatabaseAccess_proService_delete('no');
            setChecked_proService_inactive(false);
            setDatabaseAccess_proService_inactive('no');
        }
        else if(e[0] == 'suspend' && e[1] == true)
        {
            // setChecked_proService(false);
            // setDatabaseAccess_proService('no');
            setChecked_proService_active(false);
            setDatabaseAccess_proService_active('no');
            setChecked_proService_suspend(e[1]);
            setDatabaseAccess_proService_suspend('yes');
            setChecked_proService_delete(false);
            setDatabaseAccess_proService_delete('no');
            setChecked_proService_inactive(false);
            setDatabaseAccess_proService_inactive('no');
        }
        else if((e[0] == 'delete' && e[1] == true))
        {
            // setChecked_proService(false);
            // setDatabaseAccess_proService('no');
            setChecked_proService_active(false);
            setDatabaseAccess_proService_active('no');
            setChecked_proService_suspend(false);
            setDatabaseAccess_proService_suspend('no');
            setChecked_proService_delete(e[1]);
            setDatabaseAccess_proService_delete('yes');
            setChecked_proService_inactive(false);
            setDatabaseAccess_proService_inactive('no');
        }
        else if((e[0] == 'inactive' && e[1] == true))
        {
            // setChecked_proService(false);
            // setDatabaseAccess_proService('no');
            setChecked_proService_active(false);
            setDatabaseAccess_proService_active('no');
            setChecked_proService_suspend(false);
            setDatabaseAccess_proService_suspend('no');
            setChecked_proService_delete(false);
            setDatabaseAccess_proService_delete('no');
            setChecked_proService_inactive(e[1]);
            setDatabaseAccess_proService_inactive('yes');
        }
    }


    function retailManagementHandler(e)
    {

        if(e[0] == 'on' && e[1] == true)
        {

            setChecked_retail(e[1]);
            setDatabaseAccess_retail('yes');
            // setChecked_retail_active(false);
            // setDatabaseAccess_retail_active('no');
            // setChecked_retail_suspend(false);
            // setDatabaseAccess_retail_suspend('no');
            // setChecked_retail_delete(false);
            // setDatabaseAccess_retail_delete('no');
            // setChecked_retail_inactive(false);
            // setDatabaseAccess_retail_inactive('no');
        }
        if(e[0] == 'active' && e[1] == true)
        {

            // setChecked_retail(e[1]);
            // setDatabaseAccess_retail('yes');
            setChecked_retail_active(e[1]);
            setDatabaseAccess_retail_active('yes');
            setChecked_retail_suspend(false);
            setDatabaseAccess_retail_suspend('no');
            setChecked_retail_delete(false);
            setDatabaseAccess_retail_delete('no');
            setChecked_retail_inactive(false);
            setDatabaseAccess_retail_inactive('no');
        }
        else if((e[0] == 'suspend' && e[1] == true))
        {

            // setChecked_retail(false);
            // setDatabaseAccess_retail('no');
            setChecked_retail_active(false);
            setDatabaseAccess_retail_active('no');
            setChecked_retail_suspend(e[1]);
            setDatabaseAccess_retail_suspend('yes');
            setChecked_retail_delete(false);
            setDatabaseAccess_retail_delete('no');
            setChecked_retail_inactive(false);
            setDatabaseAccess_retail_inactive('no');
        }
        else if((e[0] == 'delete' && e[1] == true))
        {

            // setChecked_retail(false);
            // setDatabaseAccess_retail('no');
            setChecked_retail_active(false);
            setDatabaseAccess_retail_active('no');
            setChecked_retail_suspend(false);
            setDatabaseAccess_retail_suspend('no');
            setChecked_retail_delete(e[1]);
            setDatabaseAccess_retail_delete('yes');
            setChecked_retail_inactive(false);
            setDatabaseAccess_retail_inactive('no');
        }
        else if((e[0] == 'inactive' && e[1] == true))
        {
            // setChecked_retail(false);
            // setDatabaseAccess_retail('no');
            setChecked_retail_active(false);
            setDatabaseAccess_retail_active('no');
            setChecked_retail_suspend(false);
            setDatabaseAccess_retail_suspend('no');
            setChecked_retail_delete(false);
            setDatabaseAccess_retail_delete('no');
            setChecked_retail_inactive(e[1]);
            setDatabaseAccess_retail_inactive('yes');
        }

    }

    function jobsManagmentHandler(e)
    {

        if(e[0] == 'on' && e[1] == true)
        {
            setChecked_jobs(e[1]);
            setDatabaseAccess_jobs('yes');
            // setChecked_jobs_active(false);
            // setDatabaseAccess_jobs_active('no');
            // setChecked_jobs_suspend(false);
            // setDatabaseAccess_jobs_suspend('no');
            // setChecked_jobs(false);
            // setDatabaseAccess_jobs_delete('no');
            // setChecked_jobs_inactive(false);
            // setDatabaseAccess_jobs_inactive('no');
        }

        if(e[0] == 'active' && e[1] == true)
        {
            // setChecked_jobs(e[1]);
            // setDatabaseAccess_jobs('yes');
            setChecked_jobs_active(e[1]);
            setDatabaseAccess_jobs_active('yes');
            setChecked_jobs_suspend(false);
            setDatabaseAccess_jobs_suspend('no');
            setChecked_jobs_delete(false);
            setDatabaseAccess_jobs_delete('no');
            setChecked_jobs_inactive(false);
            setDatabaseAccess_jobs_inactive('no');
        }
        else if(e[0] == 'suspend' && e[1] == true)
        {
            // setChecked_jobs(false);
            // setDatabaseAccess_jobs('no');
            setChecked_jobs_active(false);
            setDatabaseAccess_jobs_active('no');
            setChecked_jobs_suspend(e[1]);
            setDatabaseAccess_jobs_suspend('yes');
            setChecked_jobs_delete(false);
            setDatabaseAccess_jobs_delete('no');
            setChecked_jobs_inactive(false);
            setDatabaseAccess_jobs_inactive('no');
        }
        else if((e[0] == 'delete' && e[1] == true))
        {   
            
            // setChecked_jobs(false);
            // setDatabaseAccess_jobs('no');
            setChecked_jobs_active(false);
            setDatabaseAccess_jobs_active('no');
            setChecked_jobs_suspend(false);
            setDatabaseAccess_jobs_suspend('no');
            setChecked_jobs_delete(e[1]);
            setDatabaseAccess_jobs_delete('yes');
            setChecked_jobs_inactive(false);
            setDatabaseAccess_jobs_inactive('no');
        }
        else if((e[0] == 'inactive' && e[1] == true))
        {
            // setChecked_jobs(false);
            // setDatabaseAccess_jobs('no');
            setChecked_jobs_active(false);
            setDatabaseAccess_jobs_active('no');
            setChecked_jobs_suspend(false);
            setDatabaseAccess_jobs_suspend('no');
            setChecked_jobs_delete(false);
            setDatabaseAccess_jobs_delete('no');
            setChecked_jobs_inactive(e[1]);
            setDatabaseAccess_jobs_inactive('yes');
        }
    }



    function closeModalHandler(event) {

        props.closeModal(event);
    }

    return (
        
        <React.Fragment>            
            {props.openModal == true ?
            (
                <div>
                {/* {ReactDOM.createPortal(<Backdrop />, document.getElementById('backdrop-root'))} */}

                <IonModal isOpen={ props.openModal }>
                    <IonText> Access Management </IonText>
                    <IonGrid class='gridText'>
                        <IonRow className='ionRow_capabilities'>
                            <IonCol size='2'>
                                <IonText>ON</IonText>
                            </IonCol>
                            <IonCol size='2'>
                                <IonText>ACTIVE</IonText>
                            </IonCol>
                            <IonCol size='2'>
                                <IonText>SUSPEND</IonText>
                            </IonCol>
                            <IonCol size='2'>
                                <IonText>DELETE</IonText>
                            </IonCol>
                            <IonCol size='2'>
                                <IonText>INACTIVE</IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow class='gridResultHeaders'>
                                <IonCol size='2' className="ionCol_capabilities"> FORMS </IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_forms} onIonChange={(e) => formsInvoiceHandler(['on', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_forms_active} onIonChange={(e) => formsInvoiceHandler(['active', e.detail.checked])}/></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_forms_suspend} onIonChange={(e) => formsInvoiceHandler(['suspend', e.detail.checked])}/></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_forms_delete} onIonChange={(e) => formsInvoiceHandler(['delete', e.detail.checked])}/></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_forms_inactive} onIonChange={(e) => formsInvoiceHandler(['inactive', e.detail.checked])}/></IonCol>
                        </IonRow>
                        <IonRow class='gridResultHeaders'>
                                <IonCol size='2' className="ionCol_capabilities"> HOTEL </IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_hotel} onIonChange={(e) => hotelManagementHandler(['on', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_hotel_active} onIonChange={(e) => hotelManagementHandler(['active', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_hotel_suspend} onIonChange={(e) => hotelManagementHandler(['suspend', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_hotel_delete} onIonChange={(e) => hotelManagementHandler(['delete', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_hotel_inactive} onIonChange={(e) => hotelManagementHandler(['inactive', e.detail.checked])}/></IonCol>
                        </IonRow>
                        <IonRow class='gridResultHeaders'>
                                <IonCol size='2' className="ionCol_capabilities"> EMPLOYEE </IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_employees} onIonChange={(e) => employeeManagementHandler(['on', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_employees_active} onIonChange={(e) => employeeManagementHandler(['active', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_employees_suspend} onIonChange={(e) => employeeManagementHandler(['suspend', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_employees_delete} onIonChange={(e) => employeeManagementHandler(['delete', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_employees_inactive} onIonChange={(e) => employeeManagementHandler(['inactive', e.detail.checked])}/></IonCol>
                        </IonRow>
                        <IonRow class='gridResultHeaders'>
                                <IonCol size='2' className="ionCol_capabilities"> PROSERVICE </IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_proService} onIonChange={(e) => proServiceManagementHandler(['on', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_proService_active} onIonChange={(e) => proServiceManagementHandler(['active', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_proService_suspend} onIonChange={(e) => proServiceManagementHandler(['suspend', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_proService_delete} onIonChange={(e) => proServiceManagementHandler(['delete', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_proService_inactive} onIonChange={(e) => proServiceManagementHandler(['inactive', e.detail.checked])}/></IonCol>
                        </IonRow>
                        <IonRow class='gridResultHeaders'>
                                <IonCol size='2' className="ionCol_capabilities"> RETAIL </IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_retail} onIonChange={(e) => retailManagementHandler(['on', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_retail_active} onIonChange={(e) => retailManagementHandler(['active', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_retail_suspend} onIonChange={(e) => retailManagementHandler(['suspend', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_retail_delete} onIonChange={(e) => retailManagementHandler(['delete', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_retail_inactive} onIonChange={(e) => retailManagementHandler(['inactive', e.detail.checked])}/></IonCol>
                        </IonRow>
                        <IonRow class='gridResultHeaders'>
                                <IonCol size='2' className="ionCol_capabilities"> JOBS </IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_jobs} onIonChange={(e) => jobsManagmentHandler(['on', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_jobs_active} onIonChange={(e) => jobsManagmentHandler(['active', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_jobs_suspend} onIonChange={(e) => jobsManagmentHandler(['suspend', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_jobs_delete} onIonChange={(e) => jobsManagmentHandler(['delete', e.detail.checked])} /></IonCol>
                                <IonCol size='2'><IonCheckbox checked={checked_jobs_inactive} onIonChange={(e) => jobsManagmentHandler(['inactive', e.detail.checked])}/></IonCol>
                        </IonRow>
                        <IonRow>
                            <IonButton onClick={updateMerchantAccess}> Save Changes </IonButton>
                        </IonRow>
                    </IonGrid>

                    <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                </IonModal>            
            </div>
            ) : null }
        </React.Fragment>
    )
}